<i class="ms-2 bi bi-info-circle text-muted" [ngbTooltip] [appTooltip]="tooltipKey"></i>